module.exports = __webpack_public_path__ + "static/media/29EUNOG4.e0b2d76a.jpg";